/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class PendingUploadNotification extends Component {
  @service
  options;

  @service
  students;

  // Disable ENROL arrival/leaver uploads unless specifically enabled
  // for the school, to facilitate approval testing without full release.
  @optionAlias('hero:nzMOE:enrolArrivalsLeaversEnabled')
  nzMoeEnrolArrivalsLeaversEnabled;

  // showNotification determines whether to show the "pending uploads"
  // notification/alert for NZ MoE ENROL arrival/leaver uploads.
  @computed(
    'students.{numPendingEnrolments,numPendingUnenrolments}',
    'nzMoeEnrolArrivalsLeaversEnabled',
  )
  get showNotification() {
    if (!this.nzMoeEnrolArrivalsLeaversEnabled) {
      // Not enabled - just say we don't have any pending uploads, to prevent
      // the notification/alert from showing.
      return false;
    }
    let hasPendingEnrolments = this.get('students.numPendingEnrolments') > 0;
    let hasPendingUnenrolments =
      this.get('students.numPendingUnenrolments') > 0;
    return hasPendingEnrolments || hasPendingUnenrolments;
  }
}
